import React from "react";
import "./HowToPlay.css";

const HowToPlay = () => {
  return (
    <div className="howToPlayContainer">
      <h1>Playing Chamelejon</h1>
      <h2>Round Start</h2>
      <p>
        At the start of each round a player chooses the topic category, which
        contains 15 words or phrases all closely related. Once this is confirmed
        your screen will either show you a green highlighted secret word or tell
        you that "You are the Chameleon".
      </p>
      <h2>Your go</h2>
      <p>
        On a player’s turn, they must give a clue to hint at the secret word.
        All players, including the Chameleon, will give one clue for the round.
      </p>
      <h2>Round End</h2>
      <p>
        After all players have given their hint, they then discuss and vote on
        who they think the Chameleon is, a majority must be reached or else the
        Chameleon gets away.
        <br></br>
        <br></br>
        Even if the Chameleon is discovered, they still have a chance to win the
        round by guessing the secret word. Clues therefore need to make it clear
        to everyone who knows the secret word that you also know the secret
        word, but they need be vague enough that the Chameleon can’t easily
        guess the word.
      </p>
    </div>
  );
};

export default HowToPlay;
